<div class="fecha-auto">
  @if (label()) {
    <lib-field-label
      [label]="label()"
      [required]="!automatic()"
      [tooltip]="tooltip()"
      [size]="12"
    />
  }

  <div class="fecha-auto__controles">
    <lib-datepicker
      class="fecha-auto__campo"
      [formControl]="control()"
      [required]="!automatic()"
      [label]="''"
      [disabled]="automatic()"
      [placeholder]="automatic() ? automaticPlaceholder() : manualPlaceholder()"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      [requiredMsg]="requiredMsg()"
      (dateChange)="alFijarFecha($event)"
    />

    <lib-checkbox
      class="fecha-auto__interruptor"
      [checked]="automatic()"
      [label]="automaticLabel()"
      (change)="alternarAutomatico($event)"
    />
  </div>

  @if (faltaLaFecha && requiredMsg()) {
    <div class="fecha-auto__error">{{ requiredMsg() }}</div>
  }
</div>
